// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"28":"050e147c","133":"72a23e1b","237":"f64ee50f","481":"a7dba360","513":"24d410ee","601":"a08f3310","647":"0bb9252d","745":"4d4c0d5c"}[chunkId] + ".js";
};